module.exports = __webpack_public_path__ + "static/img/special-offers-img@t.1e17880.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/haevichi/special-offers-img@t.png
// module id = GI9W
// module chunks = 0